import { formatMoney } from '../../utils/formatOpportunityValues';
export const stalePriceEvidenceLines = (evidence, texts, locale)=>[
        texts.currentRate({
            rate: formatMoney(evidence.currentRate, locale)
        }),
        evidence.monthsSinceIncrease == null ? texts.neverIncreased() : texts.monthsSinceIncrease({
            count: evidence.monthsSinceIncrease
        }),
        texts.billedInvoiceCount({
            count: evidence.billedInvoiceCount
        })
    ];
